import React from 'react'
import Loading from './Loading'

const LoadingOverlay = () => {
  return (
    <div className="fixed inset-0 bg-white bg-opacity-50 flex justify-center items-center z-50">
      <Loading />
    </div>
  )
}

export default LoadingOverlay
